export const WEBMCP_PRODUCTION_API_BASE = 'https://app.usechar.ai'
